import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const getWishListItem = data => post(URL.GET_WISHLIST_ITEM, data);
export const getWishList = data => post(URL.GET_WISHLIST_LIST, data);
export const addToWishList = data => post(URL.ADD_TO_WISHLIST, data);
export const removeFromWishList = data => post(URL.REMOVE_FROM_WISHLIST, data);